import { Component } from '@angular/core';
import { AdobeLaunchService } from 'src/app/shared/services/adobe-launch.service';

@Component({
  selector: 'terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent {

    constructor(
        private readonly adobeLaunchService: AdobeLaunchService
    ) {
    }

  ngOnInit(): void {
    this.adobeLaunchService.trackPageView({
      pageTitle:'Terms & Conditions'
    });
  }

}
